// extracted by mini-css-extract-plugin
export var chip = "_g1-0";
export var filterDropdown = "_g1-5";
export var filterItem = "_g1-6";
export var icon = "_g1-1";
export var removeButton = "_g1-3";
export var removeIcon = "_g1-4";
export var separator = "_g1-2";